import { IconClose } from './BHIcons'

function BHModal({
  children,
  confirmClose,
  onClose,
}: {
  children: React.ReactNode
  confirmClose?: () => boolean
  onClose: () => void
}) {
  function didClickClose() {
    if (confirmClose) {
      if (confirmClose()) {
        onClose()
      }
    } else {
      onClose()
    }
  }

  return (
    <div
      className="relative z-50"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
      id="modal-bg"
    >
      {/* Darken background */}
      <div className="fixed inset-0 transition-opacity bg-opacity-75 bg-primary/50" />
      <div className="fixed inset-0 z-40 overflow-y-auto">
        <div className="flex flex-1 items-center justify-center p-4 text-center sm:p-0 xs:p-0 ">

          <div
            className={`min-h-[99vh] absolute top-0 text-left transition-all transform rounded shadow-xl bg-white small:flex-none small:w-11/12 w-full box-border border-6 p-6`}
          // onClick={(e) => e.stopPropagation()}
          // onKeyPress={(e) => e.stopPropagation()}
          // tabIndex={0}
          >
            <div className="absolute top-0 right-0 z-10 hidden pt-4 pr-4 sm:block xs:block">
              <button
                type="button"
                className="p-4 -m-4 transition text-primary hover:text-primary/50"
                onClick={didClickClose}
              >
                <IconClose className="w-12 h-12" aria-label="Close panel" />
              </button>
            </div>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default BHModal
